import styled from 'styled-components';

export const EmailContentWarp = styled.div`
  @media (max-width: 750px) {
    display: block;
  }
  .error-message {
    color: red;
  }
`;
export const EmailSubmittWarp = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(props) => (props.$expiry_notify ? 'space-between' : 'flex-end')};
  .af-superadmin-template-notify-wrap {
    display: flex;
    gap: 50px;
    flex-wrap: wrap;
  }
  .af-superadmin-template-notify-toggle-label {
    margin-top: 0;
    margin-bottom: 10px;
  }
  .af-superadmin-template-notifyperiod-input-label {
    margin-top: 0;
    margin-bottom: 5px;
  }
`;
export const Label = styled.h3`
  margin-right: 10px;
  width: auto;
`;
